import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import UnstyledImage from "./image";
import { Link } from "gatsby";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { checkDarkMode } from "../utils/helpers";

const Wrapper = styled.div`
  position: relative;
  width: calc(33% - 0.8rem);
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    width: calc(50% - 0.8rem);
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    width: 100%;
  }
`;
const ImageDiv = styled(Link)`
  display: block;
  height: 350px;
  overflow: hidden;
  border-radius: var(--border-radius);
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    height: 300px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    height: 280px;
  }
`;
const TextDiv = styled(Link)`
  padding: 1.25rem 1rem;
  display: flex;
  justify-content: space-between;
  align-content: center;
  text-decoration: none;
  inset: 0;
`;
const Image = styled(UnstyledImage)`
  max-width: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease-in-out !important;
  @media (hover: hover) {
    &:hover {
      transform: scale(1.04);
      cursor: pointer;
      @media (prefers-reduced-motion) {
        transform: none;
      }
    }
  }
`;
const Title = styled.p`
  font-family: ${({ theme }) => theme.fontLinks.fontFamily};
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.darkGray};
  margin: 0;
`;
const TagWrapper = styled.div`
  position: absolute;
  top: 1rem;
  right: 12px;
  z-index: 99;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-end;
  border-radius: var(--border-radius);
`;
const BusinessClassTag = styled.div`
  font-size: 16px;
  padding: 5px 10px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 3px 0 0 3px;
  max-width: fit-content;
  margin-bottom: 10px;
  min-width: 65px;
  span {
    margin-left: 5px;
  }
`;
const Tag = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.white};
  padding: 5px 10px;
  border-radius: 3px 0 0 3px;
  &.green {
    background-color: ${({ theme }) => checkDarkMode("#3e9b2e", theme)};
  }
  &.red {
    background-color ${({ theme }) => checkDarkMode("#f2552d", theme)};
  }
  &.orange {
    background-color: ${({ theme }) => checkDarkMode("#fc8803", theme)};
  }
`;

export default function BusCard({ title, uri, image, isBusinessClass, tags }) {
  return (
    <Wrapper>
      <TagWrapper>
        {isBusinessClass && (
          <BusinessClassTag>
            <FontAwesomeIcon icon={faStar} size="sm" />
            <span>Business class</span>
          </BusinessClassTag>
        )}
        {tags?.length > 0 &&
          tags.map((tag, index) => {
            return (
              <Tag key={index} className={tag.crb_tag_color.value}>
                {tag.text}
              </Tag>
            );
          })}
      </TagWrapper>

      <ImageDiv to={uri}>
        <Image image={image} />
      </ImageDiv>
      <TextDiv to={uri}>
        <Title dangerouslySetInnerHTML={{ __html: title }} />
      </TextDiv>
    </Wrapper>
  );
}
BusCard.propTypes = {
  title: PropTypes.string,
  uri: PropTypes.string,
  image: PropTypes.object,
  isBusinessClass: PropTypes.bool,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string,
        })
      ),
      text: PropTypes.string,
    })
  ),
};
BusCard.defaultProps = {
  title: undefined,
  uri: undefined,
  image: undefined,
  isBusinessClass: false,
};
